import { type MenuItem, type MenuSection } from './types';

export type MobileSidebarRenderSection = MenuItem[];

export const expandDesktopSectionsForMobile = (sections: MenuSection[]): MobileSidebarRenderSection[] =>
    sections.flatMap(expandSectionIntoBlocks);

const expandSectionIntoBlocks = (section: MenuSection): MobileSidebarRenderSection[] => {
    const blocks: MobileSidebarRenderSection[] = [];
    let currentBlock: MobileSidebarRenderSection = [];

    for (const item of section) {
        if (item.subMenuItems?.length) {
            if (currentBlock.length > 0) {
                blocks.push(currentBlock);
                currentBlock = [];
            }

            const { subMenuItems, ...parentItem } = item;

            blocks.push([
                parentItem,
                ...subMenuItems.map((subMenuItem) => {
                    return {
                        ...subMenuItem,
                        isSubItem: true,
                    };
                }),
            ]);
        } else {
            currentBlock.push(item);
        }
    }

    if (currentBlock.length > 0) {
        blocks.push(currentBlock);
    }

    return blocks;
};
